export const muiGridPrototypes = Object.freeze({
    direction: {
        key: "direction",
        type: "SELECT",
        label: "direction",
        size: 3,
        options: [
            {
                value: "row",
                label: "row",
            },
            {
                value: "row-reverse",
                label: "row-reverse",
            },
            {
                value: "column",
                label: "column",
            },
            {
                value: "column-reverse",
                label: "column-reverse",
            },
        ],
    },
    justifyContent: {
        key: "justifyContent",
        type: "SELECT",
        label: "justifyContent",
        size: 3,
        options: [
            {
                value: "flex-start",
                label: "flex-start",
            },
            {
                value: "center",
                label: "center",
            },
            {
                value: "flex-end",
                label: "flex-end",
            },
            {
                value: "space-between",
                label: "space-between",
            },
            {
                value: "space-around",
                label: "space-around",
            },
            {
                value: "space-evenly",
                label: "space-evenly",
            },
        ],
    },
    alignItems: {
        key: "alignItems",
        type: "SELECT",
        label: "alignItems",
        size: 3,
        options: [
            {
                value: "flex-start",
                label: "flex-start",
            },
            {
                value: "center",
                label: "center",
            },
            {
                value: "flex-end",
                label: "flex-end",
            },
            {
                value: "stretch",
                label: "stretch",
            },
            {
                value: "baseline",
                label: "baseline",
            },
        ],
    },
    wrap: {
        key: "wrap",
        type: "SELECT",
        label: "Wrap",
        size: 3,
        options: [
            {
                value: "wrap",
                label: "wrap",
            },
            {
                value: "nowrap",
                label: "nowrap",
            },
            {
                value: "wrap-reverse",
                label: "wrap-reverse",
            },
        ],
    },
    flexGrow: {
        key: "flexGrow",
        type: "INTEGER",
        label: "Flex Grow",
        size: 3,
    },
})

export const muiGridPrototypesDefaults = Object.freeze({
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    wrap: "wrap",
    flexGrow: "0",
})